module.exports = __webpack_public_path__ + "static/media/MAIN_GRAPHIC.a6e0e0a8.svg";